<template>
    <div>
        <div class="row" id="campaigns-stats">
            <div class="col-md-12">
                <div class="campaign-box campaign-box--no_border">
                    <div class="campaign-details-chart-title">
                        <div class="campaign-details-subtitle">
                            Mortgage Reporting
                            <info-tooltip text="View your amount spent across all campaigns for the selected date range."></info-tooltip>
                        </div>
                    </div>

                    <div class="row" v-if="loadingLooker">
                        <div class="col-md-12 text-center campaigns-summary--loading">
                            <i class="fa fa-spinner fa-spin inner-loading"></i>
                        </div>
                    </div>

                    <div class="row campaign-stats-chart" :style="loadingLooker ? 'visibility: hidden; position: absolute' : ''">
                        <div class="col-xs-12 campaign-metrics_div" v-cloak>
                            <div class="col-xs-12">
                                <div>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <span class="datepicker-label">Date range</span>
                                            <looker-date-range-picker
                                                v-model="dateRange"
                                            ></looker-date-range-picker>
                                        </div>

                                        <div class="col-sm-3">
                                            <span class="datepicker-label">Product Type</span>
                                            <multiselect
                                                :options="dimensions.loan_purposes"
                                                v-model="selectedProductType"
                                                label="label"
                                                track-by="id"
                                                :searchable="true"
                                                :multiple="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select">
                                            </multiselect>
                                        </div>

                                        <div class="col-sm-5">
                                            <span class="datepicker-label">Campaign</span>
                                            <multiselect
                                                :options="campaigns"
                                                v-model="selectedCampaign"
                                                label="label"
                                                track-by="id"
                                                :searchable="true"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select">
                                            </multiselect>
                                        </div>
                                    </div>

                                    <div class="p-t-xl">
                                        <!-- Nav tabs -->
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li v-for="(embedUrl, title) in embedUrls" role="presentation" :class="isMainTab(title) ? 'active' : ''">
                                                <a :href="'#tab-' + slugify(title)" aria-controls="home" role="tab" data-toggle="tab">{{ title }}</a>
                                            </li>
                                        </ul>

                                        <!-- Tab panes -->
                                        <div class="tab-content">
                                            <div v-for="(embedUrl, title) in embedUrls" role="tabpanel" :class="isMainTab(title) ? 'tab-pane active' : 'tab-pane'" :id="'tab-' + slugify(title)">
                                                <looker-embed-extended
                                                    :id="'looker-' + slugify(title)"
                                                    :embedUrl="embedUrl"
                                                    :filters="isCallsTab(title) ? lookerQueryCallsFilters : lookerQueryFilters"
                                                    :height="height"
                                                    type="look"
                                                ></looker-embed-extended>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <disclaimer class="m-t-lg"></disclaimer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import LookerEmbedExtended from '../looker-embed-extended';

export default {
    props: ['embedUrls', 'campaigns'],

    data() {
        return {
            vertical:            'deposits',
            height:              '1250px',
            // @todo pull this from ad set dimensions? and filter in looker somehow?
            dimensions:          {
                loan_purposes: [
                    { 'id': 'purchase', 'label': 'Purchase' },
                    { 'id': 'refinance', 'label': 'Refinance' }
                ]
            },
            lookerProductTypes:  {
                'purchase':  'Purchase',
                'refinance': 'Refi'
            },
            dateRange:           null,
            selectedProductType: [],
            selectedCampaign:    {}
        };
    },

    computed: {
        loadingLooker() {
            return this.totalSpent === null;
        },

        lookerQueryDates() {
            if (this.dateRange) {
                const adjustedEndDate = this.dateRange.end.clone().add(1, 'd');
                const range = `${this.dateRange.start.format('YYYY/MM/DD')} to ${adjustedEndDate.format('YYYY/MM/DD')}`;

                return range;
            }

            return '7 days';
        },

        lookerQueryFilters() {
            let filters = {};

            const productTypes = _.map(this.selectedProductType, productType => {
                return this.lookerProductTypes[productType.id] || [];
            });
            filters['clicksanalytics_PRODUCTION.purchase_refi'] = productTypes.length ? productTypes : [];
            filters['clicksanalytics_PRODUCTION.campaignid'] = this.selectedCampaign ? this.selectedCampaign.id : 0;
            filters['clicksanalytics_PRODUCTION.msg_date_date'] = this.lookerQueryDates;

            return filters;
        },

        lookerQueryCallsFilters() {
            return {
                'fusecallreport.TIMESTAMP_date': this.lookerQueryDates
            };
        }
    },

    methods: {
        slugify(text) {
            return text
                .toString()                     // Cast to string
                .toLowerCase()                  // Convert the string to lowercase letters
                .normalize('NFD')       // The normalize() method returns the Unicode Normalization Form of a given string.
                .trim()                         // Remove whitespace from both sides of a string
                .replace(/\s+/g, '-')           // Replace spaces with -
                .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                .replace(/\-\-+/g, '-');        // Replace multiple - with single -
        },

        isMainTab(title) {
            return this.slugify(title) === 'leads-per-hour';
        },

        isCallsTab(title) {
            return this.slugify(title) === 'calls';
        }
    },

    components: {
        Multiselect,
        LookerEmbedExtended
    }
};
</script>

<style scoped>
.tab-content {
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
}

.nav-tabs > li > a {
    border-radius: 0;
}
</style>
